import { render, staticRenderFns } from "./organizationList.vue?vue&type=template&id=39380a2b&scoped=true&"
import script from "./organizationList.vue?vue&type=script&lang=js&"
export * from "./organizationList.vue?vue&type=script&lang=js&"
import style0 from "./organizationList.vue?vue&type=style&index=0&id=39380a2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39380a2b",
  null
  
)

component.options.__file = "organizationList.vue"
export default component.exports